import { FC, PropsWithChildren } from 'react';
import { Remote } from '@fu-app/core';
import useDynamicRemotes from './useDynamicRemotes';

interface RemotesManagerProps extends PropsWithChildren {
  remotes: Remote[];
}

const RemotesManager: FC<RemotesManagerProps> = ({ remotes, children }) => {
  useDynamicRemotes(remotes);
  return children;
};

export default RemotesManager;
